<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="select"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            placeholder="Unidades..."
                            v-model="filtro.id_unidade_operacao">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load(false)">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Unidade de Internação..."
                            icon="fa-solid fa-bed fa-fw"
                            type="select"
                            optionsMode="aql"
                            :optionsName="'centro_custos.index.leito.' + filtro.id_unidade_operacao"
                            service="centro_custos.index"
                            optionsData="id_centro_custo" 
                            optionsDisplay="search"
                            :optionsParm="{ 
                                ativos: true,
                                id_unidade_operacao: filtro.id_unidade_operacao,
                                leitos: true, 
                            }"
                            v-model="filtro.id_centro_custo"  />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="button-group"
                            :optionsList="[
                                { id: 'L', search: 'Leito' }, 
                                { id: 'S', search: 'Sala Proced' }, 
                            ]"
                            optionsData="id"
                            v-model="filtro.tipo_local" 
                            @click="loadpos(false)"/>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input icon="fa fa-search fa-fw" v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="false && filtro.interno">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir()" title="Registrar Admissão">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="agendados()" title="Registrar Admissão de Paciente Agendado">
                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
            v-if="!lista.length" 
            icon="fa-solid fa-bed" 
            msg="Nenhum leito identificado." />

        <div v-else>
            <div v-if="dados.por_status">
                <div class="card">
                    <div class="card-header d-flex justify-content-between" v-if="dados.centro_custo">
                        <div>{{ dados.centro_custo.search }}</div>
                        <div>{{ dados.lista.filter(item => item.fl_exibir_mapa_sala).length }}</div>
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" 
                            :class="'list-group-item-' + status.status_leito.color"
                            v-for="(status, isx) in dados.por_status" :key="isx">
                            <div>
                                <a href="#" @click.prevent="filtrar(status.status_leito.msg)" class="card-link alert-link">
                                    {{ status.status_leito.msg }}
                                </a>
                            </div>
                            <div>
                                <span class="badge badge-light mr-3">
                                    {{ status.perc }}%
                                </span>

                                {{ status.qtde }}
                            </div>        
                        </li>
                    </ul>
                </div>
            </div>

            <div class="mb-3">

                <div class="card carde mb-2 w3-animate-opacity" v-for="(leito, ilx) in lista" :key="ilx">
                    <div class="card-body py-1 px-2">
                        <div class="row">
                            <div class="col col-12 col-md-2 d-flex flex-column">
                                <span class="badge" :class="'badge-' + leito.status_leito.color" v-if="leito.status_leito">
                                    {{ leito.status_leito.msg }}
                                </span>
                            </div>
                            <div class="col col-12 col-md-3">
                                <div class="small text-muted">
                                    {{ leito.centro_custo.unidade_operacao.st_nome }}
                                </div>
                                <div class="text-muted">
                                    {{ leito.centro_custo.st_nome }}
                                </div>
                                <div :class="( leito.internado && leito.internado.id_local_momento && leito.internado.local_momento ) ? '' : 'font-weight-bold'">
                                    {{ leito.st_local }}
                                </div>
                                <div class="font-weight-bold" v-if="leito.internado && leito.internado.local_momento">
                                    <i class="fa-solid fa-street-view fa-fw mr-2"></i>
                                    <a href="#" @click.prevent="abrir_sala_proc(leito.internado)" class="card-link">
                                        {{ leito.internado.local_momento.st_local }}
                                    </a>
                                </div>
                                <div v-else-if="leito.internado && leito.internado.local">
                                    <i class="fa-solid fa-bed fa-fw mr-2"></i>
                                    {{ leito.internado.local.st_local }}
                                </div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <template v-if="leito.internado">
                                    <celula-dados-paciente :hor="{ marcacao: { 
                                            plano: leito.internado.plano,
                                            paciente: leito.internado.paciente, 
                                        }
                                    }" />
                                </template>
                            </div>
                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                <div>
                                    <template v-if="leito.internado">
                                        <div>
                                            {{ $util.getFormatDate(leito.internado.dt_admissao) }}
                                            {{ leito.internado.st_hora_admissao }}
                                        </div>
                                        <div class="small text-muted" v-if="leito.internado.st_motivo">
                                            {{ leito.internado.st_motivo }}
                                        </div>
                                        <div v-if="leito.internado.js_classes && leito.internado.js_classes.length">
                                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in leito.internado.js_classes" :key="icx">
                                                <span class="badge badge-success mr-1">
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </div>
                                    </template>
                                </div>

                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" @click="transferir(leito)" v-if="leito.internado">
                                            Transferir
                                        </button>

                                        <button class="dropdown-item" @click="bloquear(leito)" v-if="!leito.internado">
                                            Bloquear/Desbloquear
                                        </button>

                                        <template v-if="leito.internado">

                                            <div class="divider"></div>

                                            <button class="dropdown-item" @click="historico(leito)">
                                                Histórico
                                            </button>

                                            <button class="dropdown-item" @click="abrir_sala_proc(leito.internado)">
                                                Sala de Procedimento
                                            </button>

                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Sem Leito -->
            <div class="card carde mb-2 w3-animate-opacity" v-for="(internacao, ilx) in lista_sem_leito" :key="ilx">
                <div class="card-body py-1 px-2">
                    <div class="row">
                        <div class="col col-12 col-md-2 d-flex flex-column">
                            <span class="badge badge-secondary">
                                Sem Leito
                            </span>
                        </div>
                        <div class="col col-12 col-md-3">
                        </div>
                        <div class="col col-12 col-md-3">
                            <celula-dados-paciente :hor="{ marcacao: { 
                                    plano: internacao.plano,
                                    paciente: internacao.paciente, 
                                }
                            }" />
                        </div>
                        <div class="col col-12 col-md-4 d-flex justify-content-between">
                            <div>
                                <template v-if="internacao">
                                    <div>
                                        {{ $util.getFormatDate(internacao.dt_admissao) }}
                                        {{ internacao.st_hora_admissao }}
                                    </div>
                                    <div class="small text-muted" v-if="internacao.st_motivo">
                                        {{ internacao.st_motivo }}
                                    </div>
                                    <div v-if="internacao.js_classes && internacao.js_classes.length">
                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in internacao.js_classes" :key="icx">
                                            <span class="badge badge-success mr-1">
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </div>
                                </template>
                            </div>

                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" @click="selecionar_leito(internacao)">
                                        Selecionar Leito
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <pre v-if="false">{{ dados }}</pre>

            <transferir-leito ref="transf" @refresh="load()" />

            <bloqueio-leito ref="bloqueio" @refresh="load()" />

            <!-- Selecionar Leito -->
            <selecao-leito ref="selecao_leito" @refresh="load()" />

            <!-- Histórico de Leito -->
            <leito-historico ref="historico" />

            <!-- Sala de Procedimento -->
            <sala-de-procedimento ref="sala_proc" @refresh="load()" />
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import TransferirLeito from './TransferirLeito.vue';
import BloqueioLeito from './BloqueioLeito.vue';
import SelecaoLeito from './SelecaoLeito.vue';
import LeitoHistorico from './LeitoHistorico.vue';
import SalaDeProcedimento from './SalaDeProcedimento.vue';

export default {
    data() { 
        return { 
            dados: null, 
            filtro: { 
                id_unidade_operacao: "",
                id_centro_custo: "", 
                search: "", 
                tipo_local: "L",
            }
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        CelulaDadosPaciente, 
        TransferirLeito,
        BloqueioLeito, 
        SelecaoLeito,
        LeitoHistorico,
        SalaDeProcedimento
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtro.search);
            
            return this.dados.lista.filter(item => item.fl_exibir_mapa_sala)
                .filter (item => { 
                    return ( !this.filtro.search || reg.test(JSON.stringify(item)) );
                });
        },

        lista_sem_leito: function () { 
            if ( !this.dados || !this.dados.sem_leitos )
                return [];

            let reg = this.$util.getregex(this.filtro.search);
            
            return this.dados.sem_leitos.filter (item => { 
                return ( !this.filtro.search || reg.test(JSON.stringify(item)) );
            });
        },
    },

    methods: { 
        loadpos () { 
            this.$nextTick(() => { 
                this.load(true);
            });
        },
        
        abrir_sala_proc (item) { 
            this.$refs.sala_proc.abrir(item.id_internacao);
        },

        historico (item) { 
            this.$refs.historico.abrir(item.internado.id_internacao);
        },

        selecionar_leito (item) { 
            item.local = null; 
            this.$refs.selecao_leito.abrir(item);
        },

        bloquear (leito) { 
            this.$refs.bloqueio.bloquear(leito);
        },

        transferir (leito) { 
            this.$refs.transf.transferir(leito.internado, leito);
        },

        filtrar(classe) { 
            if ( this.filtro.search == '\x22' + classe + '\x22' ) { 
                this.filtro.search = ''
            } else { 
                this.filtro.search = '\x22' + classe + '\x22'
            }
        },

        load() { 

            if ( this.filtro.id_unidade_operacao != this.$util.getCookie('id_unidade_operacao') ) { 
                this.$util.setCookie('id_unidade_operacao', this.filtro.id_unidade_operacao);
            }

            if ( this.filtro.id_centro_custo != this.$util.getCookie('int-cc') ) { 
                this.$util.setCookie('int-cc', this.filtro.id_centro_custo, 365);
            }

            this.$util.load(this, { 
                service: 'locals',
                parms: { 
                    ativos: true, 
                    leitos: true,
                    mapa_leitos: true,
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

    beforeMount () { 

        this.filtro.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao'), 
        this.filtro.id_centro_custo = this.$util.getCookie('int-cc')
            ? this.$util.getCookie('int-cc')
            : "";
        
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Internação", path: "/internacao/internados" },
            { name: "Leitos", path: "/internacao/leitos" }
        ]);

        this.load();
    }
}
</script>